/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type ConditionType = "contains" | "endsWith" | "equals" | "greaterThan" | "greaterThanOrEqual" | "inRange" | "lessThan" | "lessThanOrEqual" | "notContains" | "notEqual" | "startsWith" | "%future added value";
export type ContractTypeType = "ASP" | "B2C_ONE_TIME" | "DWA_CONTRACTOR" | "DWA_SUBCONTRACTOR" | "MINI_MAINTENANCE_CONTRACT" | "MISC_SERVICE" | "NONE" | "ONE_TIME_EXTERNAL_MAINTENANCE" | "ONE_TIME_GRAFFITI" | "ONLY_TS_ON_DEMAND" | "REMOTE_MAINTENANCE_CONTRACT" | "SD_MAINTENANCE_CONTRACT" | "SD_PURCHASE_ASSEMBLY_NO_TS" | "SD_PURCHASE_ASSEMBLY_TS_ON_DEMAND" | "SD_PURCHASE_WITHOUT_ASSEMBLY" | "UMBRELLA_GRAFFITI" | "%future added value";
export type Condition = {|
  value: $ReadOnlyArray<?string>,
  type: ConditionType,
|};
export type AppointmentsOverviewQueryVariables = {|
  companyId: string,
  dateFilter: $ReadOnlyArray<?Condition>,
  serviceFilter: $ReadOnlyArray<?Condition>,
  contractFilter: $ReadOnlyArray<?Condition>,
|};
export type AppointmentsOverviewQueryResponse = {|
  +Me: ?{|
    +Company: ?{|
      +regularDone: number,
      +serviceDone: number,
      +specialDone: number,
      +regularPending: number,
      +servicePending: number,
      +specialPending: number,
      +regularNotDone: number,
      +serviceNotDone: number,
      +specialNotDone: number,
      +Contracts: ?$ReadOnlyArray<?{|
        +id: string,
        +tableId: number,
        +name: ?string,
        +type: ?ContractTypeType,
        +billingPeriods: $ReadOnlyArray<?{|
          +id: string,
          +tableId: number,
          +from: any,
          +to: ?any,
        |}>,
        +serviceCategory: ?{|
          +id: string,
          +tableId: number,
          +name: string,
        |},
      |}>,
    |}
  |}
|};
export type AppointmentsOverviewQuery = {|
  variables: AppointmentsOverviewQueryVariables,
  response: AppointmentsOverviewQueryResponse,
|};
*/


/*
query AppointmentsOverviewQuery(
  $companyId: ID!
  $dateFilter: [Condition]!
  $serviceFilter: [Condition]!
  $contractFilter: [Condition]!
) {
  Me {
    Company(id: $companyId) {
      regularDone: countAppointments(options: {filters: [{name: "type", filterType: text, operator: AND, conditions: [{value: ["T1", "T2"], type: equals}]}, {name: "status", filterType: text, operator: AND, conditions: [{value: ["DONE", "CLOSED", "CHECKED"], type: equals}]}, {name: "date", filterType: date, operator: AND, conditions: $dateFilter}, {name: "contract.serviceCategory.tableId", filterType: text, operator: AND, conditions: $serviceFilter}, {name: "contract", filterType: number, operator: AND, conditions: $contractFilter}]})
      serviceDone: countAppointments(options: {filters: [{name: "type", filterType: text, operator: AND, conditions: [{value: ["TI", "TS"], type: equals}]}, {name: "status", filterType: text, operator: AND, conditions: [{value: ["DONE", "CLOSED", "CHECKED"], type: equals}]}, {name: "date", filterType: date, operator: AND, conditions: $dateFilter}, {name: "contract.serviceCategory.tableId", filterType: text, operator: AND, conditions: $serviceFilter}, {name: "contract", filterType: number, operator: AND, conditions: $contractFilter}]})
      specialDone: countAppointments(options: {filters: [{name: "type", filterType: text, operator: AND, conditions: [{value: ["TX", "TA"], type: equals}]}, {name: "status", filterType: text, operator: AND, conditions: [{value: ["DONE", "CLOSED", "CHECKED"], type: equals}]}, {name: "date", filterType: date, operator: AND, conditions: $dateFilter}, {name: "contract.serviceCategory.tableId", filterType: text, operator: AND, conditions: $serviceFilter}, {name: "contract", filterType: number, operator: AND, conditions: $contractFilter}]})
      regularPending: countAppointments(options: {filters: [{name: "type", filterType: text, operator: AND, conditions: [{value: ["T1", "T2"], type: equals}]}, {name: "status", filterType: text, operator: AND, conditions: [{value: ["OPEN", "DIAGNOSE_PENDING"], type: equals}]}, {name: "date", filterType: date, operator: AND, conditions: $dateFilter}, {name: "contract.serviceCategory.tableId", filterType: text, operator: AND, conditions: $serviceFilter}, {name: "contract", filterType: number, operator: AND, conditions: $contractFilter}]})
      servicePending: countAppointments(options: {filters: [{name: "type", filterType: text, operator: AND, conditions: [{value: ["TI", "TS"], type: equals}]}, {name: "status", filterType: text, operator: AND, conditions: [{value: ["OPEN", "DIAGNOSE_PENDING"], type: equals}]}, {name: "date", filterType: date, operator: AND, conditions: $dateFilter}, {name: "contract.serviceCategory.tableId", filterType: text, operator: AND, conditions: $serviceFilter}, {name: "contract", filterType: number, operator: AND, conditions: $contractFilter}]})
      specialPending: countAppointments(options: {filters: [{name: "type", filterType: text, operator: AND, conditions: [{value: ["TX", "TA"], type: equals}]}, {name: "status", filterType: text, operator: AND, conditions: [{value: ["OPEN", "DIAGNOSE_PENDING"], type: equals}]}, {name: "date", filterType: date, operator: AND, conditions: $dateFilter}, {name: "contract.serviceCategory.tableId", filterType: text, operator: AND, conditions: $serviceFilter}, {name: "contract", filterType: number, operator: AND, conditions: $contractFilter}]})
      regularNotDone: countAppointments(options: {filters: [{name: "type", filterType: text, operator: AND, conditions: [{value: ["T1", "T2"], type: equals}]}, {name: "status", filterType: text, operator: AND, conditions: [{value: ["DEACTIVATED"], type: equals}]}, {name: "date", filterType: date, operator: AND, conditions: $dateFilter}, {name: "contract.serviceCategory.tableId", filterType: text, operator: AND, conditions: $serviceFilter}, {name: "contract", filterType: number, operator: AND, conditions: $contractFilter}]})
      serviceNotDone: countAppointments(options: {filters: [{name: "type", filterType: text, operator: AND, conditions: [{value: ["TI", "TS"], type: equals}]}, {name: "status", filterType: text, operator: AND, conditions: [{value: ["DEACTIVATED"], type: equals}]}, {name: "date", filterType: date, operator: AND, conditions: $dateFilter}, {name: "contract.serviceCategory.tableId", filterType: text, operator: AND, conditions: $serviceFilter}, {name: "contract", filterType: number, operator: AND, conditions: $contractFilter}]})
      specialNotDone: countAppointments(options: {filters: [{name: "type", filterType: text, operator: AND, conditions: [{value: ["TX", "TA"], type: equals}]}, {name: "status", filterType: text, operator: AND, conditions: [{value: ["DEACTIVATED"], type: equals}]}, {name: "date", filterType: date, operator: AND, conditions: $dateFilter}, {name: "contract.serviceCategory.tableId", filterType: text, operator: AND, conditions: $serviceFilter}, {name: "contract", filterType: number, operator: AND, conditions: $contractFilter}]})
      Contracts(options: {endRow: -1}) {
        id
        tableId
        name
        type
        billingPeriods(options: {endRow: -1}) {
          id
          tableId
          from
          to
        }
        serviceCategory {
          id
          tableId
          name
        }
      }
      id
    }
    id
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "companyId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "contractFilter"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "dateFilter"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "serviceFilter"
},
v4 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "companyId"
  }
],
v5 = {
  "kind": "Literal",
  "name": "filters.0",
  "value": {
    "conditions": [
      {
        "type": "equals",
        "value": [
          "T1",
          "T2"
        ]
      }
    ],
    "filterType": "text",
    "name": "type",
    "operator": "AND"
  }
},
v6 = {
  "kind": "Literal",
  "name": "filters.1",
  "value": {
    "conditions": [
      {
        "type": "equals",
        "value": [
          "DONE",
          "CLOSED",
          "CHECKED"
        ]
      }
    ],
    "filterType": "text",
    "name": "status",
    "operator": "AND"
  }
},
v7 = {
  "kind": "Literal",
  "name": "operator",
  "value": "AND"
},
v8 = {
  "fields": [
    {
      "kind": "Variable",
      "name": "conditions",
      "variableName": "dateFilter"
    },
    {
      "kind": "Literal",
      "name": "filterType",
      "value": "date"
    },
    {
      "kind": "Literal",
      "name": "name",
      "value": "date"
    },
    (v7/*: any*/)
  ],
  "kind": "ObjectValue",
  "name": "filters.2"
},
v9 = {
  "fields": [
    {
      "kind": "Variable",
      "name": "conditions",
      "variableName": "serviceFilter"
    },
    {
      "kind": "Literal",
      "name": "filterType",
      "value": "text"
    },
    {
      "kind": "Literal",
      "name": "name",
      "value": "contract.serviceCategory.tableId"
    },
    (v7/*: any*/)
  ],
  "kind": "ObjectValue",
  "name": "filters.3"
},
v10 = {
  "fields": [
    {
      "kind": "Variable",
      "name": "conditions",
      "variableName": "contractFilter"
    },
    {
      "kind": "Literal",
      "name": "filterType",
      "value": "number"
    },
    {
      "kind": "Literal",
      "name": "name",
      "value": "contract"
    },
    (v7/*: any*/)
  ],
  "kind": "ObjectValue",
  "name": "filters.4"
},
v11 = {
  "alias": "regularDone",
  "args": [
    {
      "fields": [
        {
          "items": [
            (v5/*: any*/),
            (v6/*: any*/),
            (v8/*: any*/),
            (v9/*: any*/),
            (v10/*: any*/)
          ],
          "kind": "ListValue",
          "name": "filters"
        }
      ],
      "kind": "ObjectValue",
      "name": "options"
    }
  ],
  "kind": "ScalarField",
  "name": "countAppointments",
  "storageKey": null
},
v12 = {
  "kind": "Literal",
  "name": "filters.0",
  "value": {
    "conditions": [
      {
        "type": "equals",
        "value": [
          "TI",
          "TS"
        ]
      }
    ],
    "filterType": "text",
    "name": "type",
    "operator": "AND"
  }
},
v13 = {
  "alias": "serviceDone",
  "args": [
    {
      "fields": [
        {
          "items": [
            (v12/*: any*/),
            (v6/*: any*/),
            (v8/*: any*/),
            (v9/*: any*/),
            (v10/*: any*/)
          ],
          "kind": "ListValue",
          "name": "filters"
        }
      ],
      "kind": "ObjectValue",
      "name": "options"
    }
  ],
  "kind": "ScalarField",
  "name": "countAppointments",
  "storageKey": null
},
v14 = {
  "kind": "Literal",
  "name": "filters.0",
  "value": {
    "conditions": [
      {
        "type": "equals",
        "value": [
          "TX",
          "TA"
        ]
      }
    ],
    "filterType": "text",
    "name": "type",
    "operator": "AND"
  }
},
v15 = {
  "alias": "specialDone",
  "args": [
    {
      "fields": [
        {
          "items": [
            (v14/*: any*/),
            (v6/*: any*/),
            (v8/*: any*/),
            (v9/*: any*/),
            (v10/*: any*/)
          ],
          "kind": "ListValue",
          "name": "filters"
        }
      ],
      "kind": "ObjectValue",
      "name": "options"
    }
  ],
  "kind": "ScalarField",
  "name": "countAppointments",
  "storageKey": null
},
v16 = {
  "kind": "Literal",
  "name": "filters.1",
  "value": {
    "conditions": [
      {
        "type": "equals",
        "value": [
          "OPEN",
          "DIAGNOSE_PENDING"
        ]
      }
    ],
    "filterType": "text",
    "name": "status",
    "operator": "AND"
  }
},
v17 = {
  "alias": "regularPending",
  "args": [
    {
      "fields": [
        {
          "items": [
            (v5/*: any*/),
            (v16/*: any*/),
            (v8/*: any*/),
            (v9/*: any*/),
            (v10/*: any*/)
          ],
          "kind": "ListValue",
          "name": "filters"
        }
      ],
      "kind": "ObjectValue",
      "name": "options"
    }
  ],
  "kind": "ScalarField",
  "name": "countAppointments",
  "storageKey": null
},
v18 = {
  "alias": "servicePending",
  "args": [
    {
      "fields": [
        {
          "items": [
            (v12/*: any*/),
            (v16/*: any*/),
            (v8/*: any*/),
            (v9/*: any*/),
            (v10/*: any*/)
          ],
          "kind": "ListValue",
          "name": "filters"
        }
      ],
      "kind": "ObjectValue",
      "name": "options"
    }
  ],
  "kind": "ScalarField",
  "name": "countAppointments",
  "storageKey": null
},
v19 = {
  "alias": "specialPending",
  "args": [
    {
      "fields": [
        {
          "items": [
            (v14/*: any*/),
            (v16/*: any*/),
            (v8/*: any*/),
            (v9/*: any*/),
            (v10/*: any*/)
          ],
          "kind": "ListValue",
          "name": "filters"
        }
      ],
      "kind": "ObjectValue",
      "name": "options"
    }
  ],
  "kind": "ScalarField",
  "name": "countAppointments",
  "storageKey": null
},
v20 = {
  "kind": "Literal",
  "name": "filters.1",
  "value": {
    "conditions": [
      {
        "type": "equals",
        "value": [
          "DEACTIVATED"
        ]
      }
    ],
    "filterType": "text",
    "name": "status",
    "operator": "AND"
  }
},
v21 = {
  "alias": "regularNotDone",
  "args": [
    {
      "fields": [
        {
          "items": [
            (v5/*: any*/),
            (v20/*: any*/),
            (v8/*: any*/),
            (v9/*: any*/),
            (v10/*: any*/)
          ],
          "kind": "ListValue",
          "name": "filters"
        }
      ],
      "kind": "ObjectValue",
      "name": "options"
    }
  ],
  "kind": "ScalarField",
  "name": "countAppointments",
  "storageKey": null
},
v22 = {
  "alias": "serviceNotDone",
  "args": [
    {
      "fields": [
        {
          "items": [
            (v12/*: any*/),
            (v20/*: any*/),
            (v8/*: any*/),
            (v9/*: any*/),
            (v10/*: any*/)
          ],
          "kind": "ListValue",
          "name": "filters"
        }
      ],
      "kind": "ObjectValue",
      "name": "options"
    }
  ],
  "kind": "ScalarField",
  "name": "countAppointments",
  "storageKey": null
},
v23 = {
  "alias": "specialNotDone",
  "args": [
    {
      "fields": [
        {
          "items": [
            (v14/*: any*/),
            (v20/*: any*/),
            (v8/*: any*/),
            (v9/*: any*/),
            (v10/*: any*/)
          ],
          "kind": "ListValue",
          "name": "filters"
        }
      ],
      "kind": "ObjectValue",
      "name": "options"
    }
  ],
  "kind": "ScalarField",
  "name": "countAppointments",
  "storageKey": null
},
v24 = [
  {
    "kind": "Literal",
    "name": "options",
    "value": {
      "endRow": -1
    }
  }
],
v25 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v26 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "tableId",
  "storageKey": null
},
v27 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v28 = {
  "alias": null,
  "args": (v24/*: any*/),
  "concreteType": "Contract",
  "kind": "LinkedField",
  "name": "Contracts",
  "plural": true,
  "selections": [
    (v25/*: any*/),
    (v26/*: any*/),
    (v27/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "type",
      "storageKey": null
    },
    {
      "alias": null,
      "args": (v24/*: any*/),
      "concreteType": "BillingPeriod",
      "kind": "LinkedField",
      "name": "billingPeriods",
      "plural": true,
      "selections": [
        (v25/*: any*/),
        (v26/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "from",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "to",
          "storageKey": null
        }
      ],
      "storageKey": "billingPeriods(options:{\"endRow\":-1})"
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ServiceCategory",
      "kind": "LinkedField",
      "name": "serviceCategory",
      "plural": false,
      "selections": [
        (v25/*: any*/),
        (v26/*: any*/),
        (v27/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "storageKey": "Contracts(options:{\"endRow\":-1})"
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "AppointmentsOverviewQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "Me",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v4/*: any*/),
            "concreteType": "Company",
            "kind": "LinkedField",
            "name": "Company",
            "plural": false,
            "selections": [
              (v11/*: any*/),
              (v13/*: any*/),
              (v15/*: any*/),
              (v17/*: any*/),
              (v18/*: any*/),
              (v19/*: any*/),
              (v21/*: any*/),
              (v22/*: any*/),
              (v23/*: any*/),
              (v28/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Operation",
    "name": "AppointmentsOverviewQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "Me",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v4/*: any*/),
            "concreteType": "Company",
            "kind": "LinkedField",
            "name": "Company",
            "plural": false,
            "selections": [
              (v11/*: any*/),
              (v13/*: any*/),
              (v15/*: any*/),
              (v17/*: any*/),
              (v18/*: any*/),
              (v19/*: any*/),
              (v21/*: any*/),
              (v22/*: any*/),
              (v23/*: any*/),
              (v28/*: any*/),
              (v25/*: any*/)
            ],
            "storageKey": null
          },
          (v25/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "955fbea2be5aadb1e2fe769114b55754",
    "id": null,
    "metadata": {},
    "name": "AppointmentsOverviewQuery",
    "operationKind": "query",
    "text": "query AppointmentsOverviewQuery(\n  $companyId: ID!\n  $dateFilter: [Condition]!\n  $serviceFilter: [Condition]!\n  $contractFilter: [Condition]!\n) {\n  Me {\n    Company(id: $companyId) {\n      regularDone: countAppointments(options: {filters: [{name: \"type\", filterType: text, operator: AND, conditions: [{value: [\"T1\", \"T2\"], type: equals}]}, {name: \"status\", filterType: text, operator: AND, conditions: [{value: [\"DONE\", \"CLOSED\", \"CHECKED\"], type: equals}]}, {name: \"date\", filterType: date, operator: AND, conditions: $dateFilter}, {name: \"contract.serviceCategory.tableId\", filterType: text, operator: AND, conditions: $serviceFilter}, {name: \"contract\", filterType: number, operator: AND, conditions: $contractFilter}]})\n      serviceDone: countAppointments(options: {filters: [{name: \"type\", filterType: text, operator: AND, conditions: [{value: [\"TI\", \"TS\"], type: equals}]}, {name: \"status\", filterType: text, operator: AND, conditions: [{value: [\"DONE\", \"CLOSED\", \"CHECKED\"], type: equals}]}, {name: \"date\", filterType: date, operator: AND, conditions: $dateFilter}, {name: \"contract.serviceCategory.tableId\", filterType: text, operator: AND, conditions: $serviceFilter}, {name: \"contract\", filterType: number, operator: AND, conditions: $contractFilter}]})\n      specialDone: countAppointments(options: {filters: [{name: \"type\", filterType: text, operator: AND, conditions: [{value: [\"TX\", \"TA\"], type: equals}]}, {name: \"status\", filterType: text, operator: AND, conditions: [{value: [\"DONE\", \"CLOSED\", \"CHECKED\"], type: equals}]}, {name: \"date\", filterType: date, operator: AND, conditions: $dateFilter}, {name: \"contract.serviceCategory.tableId\", filterType: text, operator: AND, conditions: $serviceFilter}, {name: \"contract\", filterType: number, operator: AND, conditions: $contractFilter}]})\n      regularPending: countAppointments(options: {filters: [{name: \"type\", filterType: text, operator: AND, conditions: [{value: [\"T1\", \"T2\"], type: equals}]}, {name: \"status\", filterType: text, operator: AND, conditions: [{value: [\"OPEN\", \"DIAGNOSE_PENDING\"], type: equals}]}, {name: \"date\", filterType: date, operator: AND, conditions: $dateFilter}, {name: \"contract.serviceCategory.tableId\", filterType: text, operator: AND, conditions: $serviceFilter}, {name: \"contract\", filterType: number, operator: AND, conditions: $contractFilter}]})\n      servicePending: countAppointments(options: {filters: [{name: \"type\", filterType: text, operator: AND, conditions: [{value: [\"TI\", \"TS\"], type: equals}]}, {name: \"status\", filterType: text, operator: AND, conditions: [{value: [\"OPEN\", \"DIAGNOSE_PENDING\"], type: equals}]}, {name: \"date\", filterType: date, operator: AND, conditions: $dateFilter}, {name: \"contract.serviceCategory.tableId\", filterType: text, operator: AND, conditions: $serviceFilter}, {name: \"contract\", filterType: number, operator: AND, conditions: $contractFilter}]})\n      specialPending: countAppointments(options: {filters: [{name: \"type\", filterType: text, operator: AND, conditions: [{value: [\"TX\", \"TA\"], type: equals}]}, {name: \"status\", filterType: text, operator: AND, conditions: [{value: [\"OPEN\", \"DIAGNOSE_PENDING\"], type: equals}]}, {name: \"date\", filterType: date, operator: AND, conditions: $dateFilter}, {name: \"contract.serviceCategory.tableId\", filterType: text, operator: AND, conditions: $serviceFilter}, {name: \"contract\", filterType: number, operator: AND, conditions: $contractFilter}]})\n      regularNotDone: countAppointments(options: {filters: [{name: \"type\", filterType: text, operator: AND, conditions: [{value: [\"T1\", \"T2\"], type: equals}]}, {name: \"status\", filterType: text, operator: AND, conditions: [{value: [\"DEACTIVATED\"], type: equals}]}, {name: \"date\", filterType: date, operator: AND, conditions: $dateFilter}, {name: \"contract.serviceCategory.tableId\", filterType: text, operator: AND, conditions: $serviceFilter}, {name: \"contract\", filterType: number, operator: AND, conditions: $contractFilter}]})\n      serviceNotDone: countAppointments(options: {filters: [{name: \"type\", filterType: text, operator: AND, conditions: [{value: [\"TI\", \"TS\"], type: equals}]}, {name: \"status\", filterType: text, operator: AND, conditions: [{value: [\"DEACTIVATED\"], type: equals}]}, {name: \"date\", filterType: date, operator: AND, conditions: $dateFilter}, {name: \"contract.serviceCategory.tableId\", filterType: text, operator: AND, conditions: $serviceFilter}, {name: \"contract\", filterType: number, operator: AND, conditions: $contractFilter}]})\n      specialNotDone: countAppointments(options: {filters: [{name: \"type\", filterType: text, operator: AND, conditions: [{value: [\"TX\", \"TA\"], type: equals}]}, {name: \"status\", filterType: text, operator: AND, conditions: [{value: [\"DEACTIVATED\"], type: equals}]}, {name: \"date\", filterType: date, operator: AND, conditions: $dateFilter}, {name: \"contract.serviceCategory.tableId\", filterType: text, operator: AND, conditions: $serviceFilter}, {name: \"contract\", filterType: number, operator: AND, conditions: $contractFilter}]})\n      Contracts(options: {endRow: -1}) {\n        id\n        tableId\n        name\n        type\n        billingPeriods(options: {endRow: -1}) {\n          id\n          tableId\n          from\n          to\n        }\n        serviceCategory {\n          id\n          tableId\n          name\n        }\n      }\n      id\n    }\n    id\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'fa7b520c7ac046292a5414c13cfff28f';

module.exports = node;
